import { Head, router, useForm } from "@inertiajs/react"

import type {
  ForumCategory,
  ForumPostFormData,
  Neighborhood,
} from "@/components/forum/forum-post-form"
import { ForumPostForm } from "@/components/forum/forum-post-form"
import AppLayout from "@/layouts/app-layout"
import { forumPostsPath } from "@/routes"

interface ForumPostsNewProps {
  post: Record<string, unknown>
  categories: ForumCategory[]
  neighborhoods: Neighborhood[]
  can_pin?: boolean
}

export default function ForumPostsNew({
  categories,
  neighborhoods,
  can_pin = false,
}: ForumPostsNewProps) {
  const { data, setData, post, processing, errors } = useForm<{
    forum_post: ForumPostFormData
  }>({
    forum_post: {
      title: "",
      content: "",
      category_id: (categories?.[0]?.id ?? "").toString(),
      neighborhood_id: (neighborhoods?.[0]?.id ?? "").toString(),
      visibility: "city",
      is_pinned: false,
      tags: "",
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    post(forumPostsPath())
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title="Crear Post" />

      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <ForumPostForm
          title="Crear post"
          data={data.forum_post}
          errors={err}
          categories={categories}
          neighborhoods={neighborhoods}
          processing={processing}
          onChange={(partial) =>
            setData("forum_post", { ...data.forum_post, ...partial })
          }
          onSubmit={submit}
          onCancel={() => router.visit("/foro")}
          submitLabel="Publicar"
          can_pin={can_pin}
        />
      </div>
    </AppLayout>
  )
}
